export const UPDATE_SUBSCRIBE_TEXT_INPUT = '@app/subscribe/updateSubscribeTextInput';
export const UPDATE_SUBSCRIBE_COUNTRY_ACTION = '@app/subscribe/updateSubscribeCountryAction';
export const UPDATE_SUBSCRIBE_CONSENT_CHECKBOX_INPUT = '@app/subscribe/updateSubscribeConsentCheckboxInput';
export const PENDING_SUBSCRIBE_REQUEST = '@app/subscribe/pendingSubscribeRequest';
export const FINISHED_SUBSCRIBE_REQUEST = '@app/subscribe/finishedSubscribeRequest';
export const UPDATE_SUBSCRIBE_REQUEST = '@app/subscribe/updateSubscribeStatus';
export const TRY_AGAIN_TO_SUBSCRIBE = '@app/subscribe/tryAgainToSubscribe';

export const updateTextInputAction = (name, { value = '', valid = true, errors = [], touched = null }) => ({
    type: UPDATE_SUBSCRIBE_TEXT_INPUT,
    name,
    data: {
        value,
        valid,
        errors,
        touched
    }
});

export const updateCountryAction = (name, {value = '', touched = null}) => ({
    type: UPDATE_SUBSCRIBE_COUNTRY_ACTION,
    name,
    data: {
        value,
        touched
    }
});

export const updateConsentCheckboxInput = (name, { value = false, touched = null }) => ({
    type: UPDATE_SUBSCRIBE_CONSENT_CHECKBOX_INPUT,
    name,
    data: {
        value,
        touched
    }
});

export const pendingRequest = () => ({
    type: PENDING_SUBSCRIBE_REQUEST
});

export const finishedRequest = () => ({
    type: FINISHED_SUBSCRIBE_REQUEST
});

export const updateRequestStatus = (status) => ({
    type: UPDATE_SUBSCRIBE_REQUEST,
    status
});

export const tryAgainToSubscribe = () => ({
    type: TRY_AGAIN_TO_SUBSCRIBE
});



// WEBPACK FOOTER //
// ./actions/SubscribeActions.js